import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconRows';
/** Renders an SVG icon. */
const SvgRows = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M26 11H6V7a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zM6 13h20v6H6zm20 12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-4h20zm2-18a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3z"
      />
    </svg>
  );
};
SvgRows.displayName = displayName;
export default SvgRows;
